import { create } from 'zustand';

interface FavoriteState {
  favorites: Set<number>;
  isFavorite: (jobId: number) => boolean;
  addFavorite: (jobId: number) => void;
  removeFavorite: (jobId: number) => void;
  toggleFavorite: (jobId: number) => void;
  initializeFavorites: (favoriteJobIds: number[]) => void;
}

export const useFavoriteStore = create<FavoriteState>((set, get) => ({
  favorites: new Set<number>(),

  isFavorite: (jobId: number) => {
    const result = get().favorites.has(jobId);
    return result;
  },

  addFavorite: (jobId: number) => {
    set((state) => ({
      favorites: new Set(state.favorites).add(jobId),
    }));
  },

  removeFavorite: (jobId: number) => {
    set((state) => {
      const newFavorites = new Set(state.favorites);
      newFavorites.delete(jobId);
      return { favorites: newFavorites };
    });
  },

  toggleFavorite: (jobId: number) => {
    const { isFavorite, addFavorite, removeFavorite } = get();
    if (isFavorite(jobId)) {
      removeFavorite(jobId);
    } else {
      addFavorite(jobId);
    }
  },

  initializeFavorites: (favoriteJobIds: number[]) => {
    set({ favorites: new Set(favoriteJobIds) });
  },
}));
